import { render } from "./Loader.vue?vue&type=template&id=24691dd7&ts=true"
import script from "./Loader.vue?vue&type=script&lang=ts"
export * from "./Loader.vue?vue&type=script&lang=ts"

import "./Loader.vue?vue&type=style&index=0&id=24691dd7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__